export const GET_PRODUCTS = 'getProducts'
export const CREATE_PRODUCT = 'createProduct'
export const UPDATE_PRODUCT = 'updateProduct'
export const DELETE_PRODUCT = 'deleteProduct'
export const ADD_IMAGE_PRODUCT = 'addImageProduct'
export const DELETE_IMAGE_PRODUCT = 'deleteImage'
export const GET_IMAGES_PRODUCT = 'getImageProduct'